import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Submitted extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "submitted";
    }
}

export function Submitted$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.Submitted", void 0, Submitted, Metadata_StringCategory$reflection());
}

export function Submitted_$ctor_Z721C83C5(aName) {
    return new Submitted(aName);
}

export class TextLanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "text_language";
    }
}

export function TextLanguage$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TextLanguage", void 0, TextLanguage, Metadata_StringCategory$reflection());
}

export function TextLanguage_$ctor_Z721C83C5(aName) {
    return new TextLanguage(aName);
}

export class TextFormat extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "text_format";
    }
}

export function TextFormat$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TextFormat", void 0, TextFormat, Metadata_StringCategory$reflection());
}

export function TextFormat_$ctor_Z721C83C5(aName) {
    return new TextFormat(aName);
}

export class TextStatus extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "text_status";
    }
}

export function TextStatus$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TextStatus", void 0, TextStatus, Metadata_StringCategory$reflection());
}

export function TextStatus_$ctor_Z721C83C5(aName) {
    return new TextStatus(aName);
}

export class TaskType extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "task_type";
    }
}

export function TaskType$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TaskType", void 0, TaskType, Metadata_StringCategory$reflection());
}

export function TaskType_$ctor_Z721C83C5(aName) {
    return new TaskType(aName);
}

export class TeacherComments extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "teacher_comments";
    }
}

export function TeacherComments$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TeacherComments", void 0, TeacherComments, Metadata_StringCategory$reflection());
}

export function TeacherComments_$ctor_Z721C83C5(aName) {
    return new TeacherComments(aName);
}

export class TeacherCode extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "teacher_code";
    }
}

export function TeacherCode$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TeacherCode", void 0, TeacherCode, Metadata_StringCategory$reflection());
}

export function TeacherCode_$ctor_Z721C83C5(aName) {
    return new TeacherCode(aName);
}

export class PupilCode extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pupil_code";
    }
}

export function PupilCode$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.PupilCode", void 0, PupilCode, Metadata_StringCategory$reflection());
}

export function PupilCode_$ctor_Z721C83C5(aName) {
    return new PupilCode(aName);
}

export class SchoolYear extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "school_year";
    }
}

export function SchoolYear$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.SchoolYear", void 0, SchoolYear, Metadata_StringCategory$reflection());
}

export function SchoolYear_$ctor_Z721C83C5(aName) {
    return new SchoolYear(aName);
}

export class EducationProgram extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "education_program";
    }
}

export function EducationProgram$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.EducationProgram", void 0, EducationProgram, Metadata_StringCategory$reflection());
}

export function EducationProgram_$ctor_Z721C83C5(aName) {
    return new EducationProgram(aName);
}

export class Level extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "level";
    }
}

export function Level$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.Level", void 0, Level, Metadata_StringCategory$reflection());
}

export function Level_$ctor_Z721C83C5(aName) {
    return new Level(aName);
}

export class Gender extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "gender";
    }
}

export function Gender$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.Gender", void 0, Gender, Metadata_StringCategory$reflection());
}

export function Gender_$ctor_Z721C83C5(aName) {
    return new Gender(aName);
}

export class BirthCountry extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth_country";
    }
}

export function BirthCountry$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.BirthCountry", void 0, BirthCountry, Metadata_StringCategory$reflection());
}

export function BirthCountry_$ctor_Z721C83C5(aName) {
    return new BirthCountry(aName);
}

export class PupilsL1 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pupils_l1";
    }
}

export function PupilsL1$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.PupilsL1", void 0, PupilsL1, Metadata_StringCategory$reflection());
}

export function PupilsL1_$ctor_Z721C83C5(aName) {
    return new PupilsL1(aName);
}

export class Parent1L1 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "parent1_l1";
    }
}

export function Parent1L1$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.Parent1L1", void 0, Parent1L1, Metadata_StringCategory$reflection());
}

export function Parent1L1_$ctor_Z721C83C5(aName) {
    return new Parent1L1(aName);
}

export class Parent2L1 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "parent2_l1";
    }
}

export function Parent2L1$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.Parent2L1", void 0, Parent2L1, Metadata_StringCategory$reflection());
}

export function Parent2L1_$ctor_Z721C83C5(aName) {
    return new Parent2L1(aName);
}

export class OtherCountries extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "other_countries";
    }
}

export function OtherCountries$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.OtherCountries", void 0, OtherCountries, Metadata_StringCategory$reflection());
}

export function OtherCountries_$ctor_Z721C83C5(aName) {
    return new OtherCountries(aName);
}

export class OtherCountriesWhichWhen extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "other_countries_which_when";
    }
}

export function OtherCountriesWhichWhen$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.OtherCountriesWhichWhen", void 0, OtherCountriesWhichWhen, Metadata_StringCategory$reflection());
}

export function OtherCountriesWhichWhen_$ctor_Z721C83C5(aName) {
    return new OtherCountriesWhichWhen(aName);
}

export class LanguagesRead extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "languages_read";
    }
}

export function LanguagesRead$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.LanguagesRead", void 0, LanguagesRead, Metadata_StringCategory$reflection());
}

export function LanguagesRead_$ctor_Z721C83C5(aName) {
    return new LanguagesRead(aName);
}

export class LanguagesWrite extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "languages_write";
    }
}

export function LanguagesWrite$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.LanguagesWrite", void 0, LanguagesWrite, Metadata_StringCategory$reflection());
}

export function LanguagesWrite_$ctor_Z721C83C5(aName) {
    return new LanguagesWrite(aName);
}

export class LanguagesSpeak extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "languages_speak";
    }
}

export function LanguagesSpeak$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.LanguagesSpeak", void 0, LanguagesSpeak, Metadata_StringCategory$reflection());
}

export function LanguagesSpeak_$ctor_Z721C83C5(aName) {
    return new LanguagesSpeak(aName);
}

export class LanguagesComprehend extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "languages_comprehend";
    }
}

export function LanguagesComprehend$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.LanguagesComprehend", void 0, LanguagesComprehend, Metadata_StringCategory$reflection());
}

export function LanguagesComprehend_$ctor_Z721C83C5(aName) {
    return new LanguagesComprehend(aName);
}

export class SchoolLangs extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "school_langs";
    }
}

export function SchoolLangs$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.SchoolLangs", void 0, SchoolLangs, Metadata_StringCategory$reflection());
}

export function SchoolLangs_$ctor_Z721C83C5(aName) {
    return new SchoolLangs(aName);
}

export class SchoolLangsYear extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "school_langs_year";
    }
}

export function SchoolLangsYear$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.SchoolLangsYear", void 0, SchoolLangsYear, Metadata_StringCategory$reflection());
}

export function SchoolLangsYear_$ctor_Z721C83C5(aName) {
    return new SchoolLangsYear(aName);
}

export class LearningStart extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "learning_start";
    }
}

export function LearningStart$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.LearningStart", void 0, LearningStart, Metadata_StringCategory$reflection());
}

export function LearningStart_$ctor_Z721C83C5(aName) {
    return new LearningStart(aName);
}

export class HowLongStayCountry extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "how_long_stay_country";
    }
}

export function HowLongStayCountry$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HowLongStayCountry", void 0, HowLongStayCountry, Metadata_StringCategory$reflection());
}

export function HowLongStayCountry_$ctor_Z721C83C5(aName) {
    return new HowLongStayCountry(aName);
}

export class HoursInternet extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_internet";
    }
}

export function HoursInternet$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursInternet", void 0, HoursInternet, Metadata_StringCategory$reflection());
}

export function HoursInternet_$ctor_Z721C83C5(aName) {
    return new HoursInternet(aName);
}

export class HoursBooks extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_books";
    }
}

export function HoursBooks$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursBooks", void 0, HoursBooks, Metadata_StringCategory$reflection());
}

export function HoursBooks_$ctor_Z721C83C5(aName) {
    return new HoursBooks(aName);
}

export class HoursGames extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_games";
    }
}

export function HoursGames$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursGames", void 0, HoursGames, Metadata_StringCategory$reflection());
}

export function HoursGames_$ctor_Z721C83C5(aName) {
    return new HoursGames(aName);
}

export class HoursEmail extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_email";
    }
}

export function HoursEmail$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursEmail", void 0, HoursEmail, Metadata_StringCategory$reflection());
}

export function HoursEmail_$ctor_Z721C83C5(aName) {
    return new HoursEmail(aName);
}

export class HoursTalk extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_talk";
    }
}

export function HoursTalk$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursTalk", void 0, HoursTalk, Metadata_StringCategory$reflection());
}

export function HoursTalk_$ctor_Z721C83C5(aName) {
    return new HoursTalk(aName);
}

export class HoursMoviesSubtitles extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_movies_subtitles";
    }
}

export function HoursMoviesSubtitles$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursMoviesSubtitles", void 0, HoursMoviesSubtitles, Metadata_StringCategory$reflection());
}

export function HoursMoviesSubtitles_$ctor_Z721C83C5(aName) {
    return new HoursMoviesSubtitles(aName);
}

export class HoursMoviesNoSubtitles extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_movies_no_subtitles";
    }
}

export function HoursMoviesNoSubtitles$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursMoviesNoSubtitles", void 0, HoursMoviesNoSubtitles, Metadata_StringCategory$reflection());
}

export function HoursMoviesNoSubtitles_$ctor_Z721C83C5(aName) {
    return new HoursMoviesNoSubtitles(aName);
}

export class HoursRadio extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_radio";
    }
}

export function HoursRadio$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursRadio", void 0, HoursRadio, Metadata_StringCategory$reflection());
}

export function HoursRadio_$ctor_Z721C83C5(aName) {
    return new HoursRadio(aName);
}

export class HoursOther extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hours_other";
    }
}

export function HoursOther$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.HoursOther", void 0, HoursOther, Metadata_StringCategory$reflection());
}

export function HoursOther_$ctor_Z721C83C5(aName) {
    return new HoursOther(aName);
}

export class TaskCode extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "task_code";
    }
}

export function TaskCode$reflection() {
    return class_type("Corpora.TrawlFr.MetadataCategories.TaskCode", void 0, TaskCode, Metadata_StringCategory$reflection());
}

export function TaskCode_$ctor_Z721C83C5(aName) {
    return new TaskCode(aName);
}

